import { Typography } from "ui/typography/typography";
import { InfoMessageRoot } from "ui/info-message/info-message.styles";
import { type InfoMessageProps } from "ui/info-message/info-message.types";

import Icons from "assets";

export const InfoMessage = ({
  children,
  color = "primary",
  size = "medium",
  variant = "standard",
  ...rest
}: InfoMessageProps) => (
  <InfoMessageRoot messageColor={color} messageSize={size} messageVariant={variant} {...rest}>
    <Icons.ExclamationCircle aria-hidden />
    <Typography color="inherit" component="p" variant="inherit">
      {children}
    </Typography>
  </InfoMessageRoot>
);
